import { Controller } from "@hotwired/stimulus"

// 表のクライアントサイドソート。ヘッダ <th data-column-index="N" data-numeric="true"
// data-action="click->table-sort#sort"> をクリックで tbody の行（tr[data-sortable]）を
// 当該列で昇降順ソートする。tfoot（合計行）はソート対象外。
// 各セルは data-sort-value を持つとその値で、無ければ表示テキストで比較する。
export default class extends Controller {
  sort(event) {
    const header = event.currentTarget
    const index = parseInt(header.dataset.columnIndex, 10)
    const numeric = header.dataset.numeric === "true"
    const direction = header.dataset.direction === "asc" ? "desc" : "asc"

    this.element.querySelectorAll("th[data-column-index]").forEach((other) => {
      delete other.dataset.direction
    })
    header.dataset.direction = direction

    const body = this.element.querySelector("tbody")
    const rows = Array.from(body.querySelectorAll("tr[data-sortable]"))
    rows.sort((a, b) => {
      const av = this.cellValue(a, index)
      const bv = this.cellValue(b, index)
      const cmp = numeric ? parseFloat(av || 0) - parseFloat(bv || 0) : String(av).localeCompare(String(bv), "ja")
      return direction === "asc" ? cmp : -cmp
    })
    rows.forEach((row) => body.appendChild(row))
  }

  cellValue(row, index) {
    const cell = row.children[index]
    if (!cell) return ""
    return cell.dataset.sortValue !== undefined ? cell.dataset.sortValue : cell.textContent.trim()
  }
}
